import {useCallback} from 'react';
import {toast} from 'react-toastify';

import {ImageService} from '../Services/ImageService';

type UploadCallback = (id: number) => void;

export function useOnDrop(imageService: ImageService, onUpload: UploadCallback) {
  return useCallback(async acceptedFiles => {
    if (acceptedFiles.length === 0) {
      return;
    }

    const file = acceptedFiles[0];
    try {
      const res = await imageService.create(file);
      if (res.parsedBody !== undefined) {
        toast.success("Image uploaded");
        onUpload(res.parsedBody.id);
      }
    } catch (e) {
      toast.error("Failed to upload image");
    }
  }, [imageService, onUpload]);
}

